<form
  class="auth-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  novalidate
>
  <app-input
    id="auth-login-email"
    label="Correo electrónico"
    type="email"
    placeholder="tu@correo.com"
    formControlName="email"
  />

  <app-input
    id="auth-login-password"
    label="Contraseña"
    type="password"
    placeholder="••••••••"
    formControlName="password"
  />

  @if (errorMessage()) {
    <p class="auth-form__error" role="alert">{{ errorMessage() }}</p>
  }

  <app-button
    variant="primary"
    size="lg"
    type="submit"
    [loading]="loading()"
    [disabled]="loading()"
  >
    Iniciar sesión
  </app-button>

  <div class="auth-form__links">
    <button type="button" class="auth-form__link" (click)="switchToForgot()">
      ¿Olvidaste tu contraseña?
    </button>
    <button type="button" class="auth-form__link" (click)="switchToRegister()">
      ¿No tienes cuenta? Crear una
    </button>
  </div>
</form>
